export class SalesTranslationConfig {
    public saleMetrics: any;
    public saleLabels: any;
    public saleReportTitles: any;
    public saleChartDimensions: any;
}
